import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  'title',
  'body',
  'paragraph_title',
  'paragraph_body_processed',
];

export const resultAttributes = [
  'url',
  'title',
  'body',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'type',
    field: 'type',
    type: 'string',
  },
];
